import styled, { css } from 'styled-components';
import { Card } from '../Card/index.js';
import { Subscription } from '../Subscription/Subscription.js';

const StyledSubscription = styled(Subscription).withConfig({
    displayName: "styled__StyledSubscription",
    componentId: "sc-3d76412b-0"
})`
    position: relative;
    z-index: 1;

    ${(props)=>css`
        margin-bottom: ${props.theme.spacers.M};
    `}
`;
const NextCard = styled(Card).withConfig({
    displayName: "styled__NextCard",
    componentId: "sc-3d76412b-1"
})`
    position: absolute;
    pointer-events: none;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
    transition: all 0.2s;

    ${(props)=>css`
        top: ${props.theme.spacers.M};
    `}
`;
const Main = styled.div.withConfig({
    displayName: "styled__Main",
    componentId: "sc-3d76412b-2"
})`
    display: flex;
    flex-direction: column;
    position: relative;
    width: 100%;

    ${(props)=>css`
        &:hover {
            ${NextCard} {
                left: ${props.theme.spacers.M};
                right: ${props.theme.spacers.M};
            }
        }
    `}
`;
const QuantityIndicator = styled.div.withConfig({
    displayName: "styled__QuantityIndicator",
    componentId: "sc-3d76412b-3"
})`
    ${(props)=>css(props.theme.typography.SuperTinyHeadline)};
    height: 32px;
    width: 32px;
    border-radius: 16px;
    background-color: ${({ theme , $color  })=>$color ?? theme.colors.secondary};
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    color: ${(props)=>props.theme.colors.Background};
`;

export { Main, NextCard, QuantityIndicator, StyledSubscription };
